"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_router_dom_1 = require("react-router-dom");
var Search_1 = require("./Search");
var Filters_1 = require("./Filters");
var ListContainer_1 = require("./ListContainer");
var Icon_1 = require("components/Icon");
var ProjectActions = require("@caddigital/sok-reducers/lib/actions/projects");
var AuthActions = require("@caddigital/sok-reducers/lib/actions/auth/zendesk");
var copy_1 = require("@caddigital/sok-reducers/lib/actions/project/copy");
var delete_1 = require("@caddigital/sok-reducers/lib/actions/project/delete");
var CopyProjectModal_1 = require("./CopyProjectModal");
var DeleteProjectModal_1 = require("./DeleteProjectModal");
var Types = require("types");
var translate_1 = require("utils/translate");
require("./style.scss");
/**
 * Filter and sort projects listing and remap the state for connect
 * @param {Object} state.projects - Projects reducer
 * @returns {Object} - filtered state
 */
var mapStateToProps = function (state) {
    var showAdminTools = state.auth.current.user
        .map(function (u) {
        return u.level === 'SuperAdminUserGroup' ||
            u.level === 'SalesmanUserGroup' ||
            false;
    })
        .getOrElse(false);
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        currentUser: state.auth.current.user,
        showBookmarked: state.projects.showBookmarked,
        showArchived: state.projects.showArchived,
        showAdminTools: showAdminTools,
        selectedLanguage: selectedLanguage,
        zToken: state.auth.zendesk.token,
        selected: state.projects.selected,
        deleteStatus: state.project.delete.status
    };
};
exports.mapStateToProps = mapStateToProps;
/**
 * Map projects actions for connect
 * @param {Object} actions - Projects actions
 * @param {Function} dispatch - Function to dispatch the actions
 * @returns {Object}
 */
var mapDispatchToProps = function (dispatch) { return ({
    onFetchProjects: function () { return dispatch(ProjectActions.fetchProjects()); },
    zendeskToken: function () { return dispatch(AuthActions.createZendeskTokenRequest()); },
    clearToken: function () { return dispatch(AuthActions.resetZendeskToken()); },
    toggleCopyModal: function (mode, project) {
        return dispatch((0, copy_1.toggleCopyModal)(mode, project));
    },
    toggleDeleteModal: function (project) {
        return dispatch((0, delete_1.toggleDeleteModal)(project));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var zendesk = null;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ProjectList'), (0, recompose_1.withState)('deleteConfirmDialog', 'setDeleteConfirmDialog', false), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.onFetchProjects();
    },
    componentWillReceiveProps: function (nextProps) {
        if (zendesk && nextProps.zToken !== '') {
            var url = "https://sokopro.zendesk.com/access/jwt?jwt=".concat(nextProps.zToken, "&return_to=https://sokopro.zendesk.com/");
            zendesk.location.href = url;
            zendesk.focus();
            zendesk = null;
            this.props.clearToken();
        }
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { key: 'main-content', className: 'content-wrapper-content' },
            React.createElement("div", { className: 'projects-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage) }, "SokoPro"),
                        React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/projects'))),
                    React.createElement("div", { className: 'tools' },
                        props.currentUser.fold(undefined, function (u) {
                            switch (u.level) {
                                case 'SuperAdminUserGroup':
                                case 'SalesmanUserGroup':
                                case 'CustomerAdminUserGroup':
                                    var isNotCustomerAdmin = u.level !== 'CustomerAdminUserGroup';
                                    return (React.createElement(sok_ui_1.Button, { key: 'createnewproject', color: "green", icon: React.createElement(Icon_1.Icon, { className: "fa-plus" }), url: isNotCustomerAdmin
                                            ? "/".concat(props.selectedLanguage, "/admin/projects")
                                            : undefined, onClick: isNotCustomerAdmin
                                            ? undefined
                                            : function () {
                                                props.toggleCopyModal('TEMPLATE');
                                            } }, (0, translation_1.getLocalization)('admin/projectsTab/buttons/createnewproject')));
                                default:
                                    return undefined;
                            }
                        }),
                        props.showAdminTools && [
                            React.createElement(sok_ui_1.Button, { key: 'copyproject', color: "blue", icon: React.createElement(Icon_1.Icon, { className: "fa-file" }), onClick: function (e) {
                                    return props.selected.length > 0 &&
                                        props.toggleCopyModal('COPY', props.selected[0]);
                                }, disabled: props.selected.length !== 1 }, (0, translation_1.getLocalization)('dashboard/copy')),
                            React.createElement(sok_ui_1.Button, { key: 'deleteproject', color: "red", icon: React.createElement(Icon_1.Icon, { className: "fa-trash" }), onClick: function (e) {
                                    return props.selected.length > 0 &&
                                        props.toggleDeleteModal(props.selected[0]);
                                }, disabled: props.selected.length !== 1 }, (0, translation_1.getLocalization)('dashboard/delete'))
                        ],
                        React.createElement(sok_ui_1.Button, { color: "dark-gray", icon: React.createElement(Icon_1.Icon, { className: "fa-book" }), onClick: function () {
                                zendesk = window.open('about:blank', 'blank');
                                props.zendeskToken();
                            } }, (0, translation_1.getLocalization)('userFront/projectsTab/buttons/tutorials'))),
                    React.createElement(Search_1.default, null),
                    React.createElement(Filters_1.default, null),
                    React.createElement(ListContainer_1.ListContainer, { showAdminTools: props.showAdminTools, onFetchProjects: props.onFetchProjects }),
                    props.currentUser.fold(undefined, function (u) {
                        if (u.level === 'SuperAdminUserGroup' ||
                            u.level === 'SalesmanUserGroup' ||
                            u.level === 'CustomerAdminUserGroup') {
                            return React.createElement(CopyProjectModal_1.default, null);
                        }
                        return undefined;
                    }),
                    props.showAdminTools ? React.createElement(DeleteProjectModal_1.default, null) : undefined)))));
});
